import { useAppDispatch } from '@hooks/redux'
import { ReactNode, useEffect } from 'react'
import {
  setActionsButton,
  setBreadcrumbs,
  setInviteButton,
} from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { RoutePaths } from '@interfaces/routePaths'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { Profile } from './Profile'

export const Base = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const { recordId = '' } = useParams()
  const dispatch = useAppDispatch()
  const location = useLocation()

  useEffect(() => {
    dispatch(setInviteButton(true))
    dispatch(setActionsButton(true))

    if (location?.state?.history) {
      dispatch(
        setBreadcrumbs([
          ...location?.state?.history,
          {
            title: 'Alfredo Carrillo',
            href: '#',
          },
        ]),
      )
    }
  }, [])

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Home',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_HOME}`,
            index: true,
          },
          {
            label: 'Linked Records',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_LINKED_RECORDS}`,
          },
          {
            label: 'Tasks',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_TASKS}`,
            unviewed: 3,
          },
          {
            label: 'Calls',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_CALLS}`,
          },
          {
            label: 'Notes',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_NOTES}`,
          },
          {
            label: 'Files',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_FILES}`,
          },
          {
            label: 'Activity',
            path: `${RoutePaths.RECORD}/${recordId}/${RoutePaths.RECORD_ACTIVITY}`,
          },
        ]}
      />

      <Profile />

      {children}
    </>
  )
}
